export const widgetScriptSrc = (document?.currentScript as HTMLScriptElement)?.src;

export const widgetScriptLocation = widgetScriptSrc?.substring(0, widgetScriptSrc.lastIndexOf('/'));
